import React from 'react'

import { appendCssVarsPalette } from '../theme'

const ComponentLibrary = {
  NOVA: 'nova',
  MUI: 'mui',
} as const
export type ComponentLibrary = (typeof ComponentLibrary)[keyof typeof ComponentLibrary]

const DEFAULT_COMPONENT_LIBRARY = ComponentLibrary.NOVA // see also common\src\state\component-library\hooks.ts
const ComponentLibraryContext = React.createContext<ComponentLibrary>(DEFAULT_COMPONENT_LIBRARY)

type ComponentLibraryProviderProps = {
  children: React.ReactNode
  library: string | undefined
}

function isComponentLibrary(value: unknown): value is ComponentLibrary {
  return value === ComponentLibrary.MUI || value === ComponentLibrary.NOVA
}

function getGlobalComponentLibrary(): ComponentLibrary {
  const windowComponentLibrary = (window as { __COMPONENT_LIBRARY__?: ComponentLibrary }).__COMPONENT_LIBRARY__
  return isComponentLibrary(windowComponentLibrary) ? windowComponentLibrary : DEFAULT_COMPONENT_LIBRARY
}

export function ComponentLibraryProvider({ children, library }: ComponentLibraryProviderProps) {
  const componentLibrary = isComponentLibrary(library) ? (library as ComponentLibrary) : DEFAULT_COMPONENT_LIBRARY

  // Append CSS Variables for theming purpose.
  appendCssVarsPalette(componentLibrary)

  return React.createElement(ComponentLibraryContext.Provider, { value: componentLibrary }, children)
}

export function useComponentLibrary() {
  const libraryFromContext = React.useContext(ComponentLibraryContext)
  return libraryFromContext ?? getGlobalComponentLibrary()
}
